<template>
    <div class="artist" v-if="item">
        <p class="h22 artist-title" @click="open">{{item.post_title}}</p>
        <div v-if="active" class="artist-accordion" :id="item.post_name">
            <div class="language">
                <div class="col">
                    <p class="h4 artist-description text-justify" v-if="item.post_content" v-html="item.post_content "></p>
                </div>
                <div class="col">
                    <p class="h4 artist-description text-justify" v-if="item.acf.descrption_en" v-html="item.acf.descrption_en"></p>
                </div>
            </div>
            <div class="artworks">
                <Artwork v-for="(item) in artworks" :key="item.ID" :item="item" :status="false" :color="item.color" :player="false"></Artwork>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import { mapState } from 'vuex';
import Artwork from './Artwork';

export default {
    props: ['item', 'status'],
    name: 'programme',
    data() {
        return {
            data: null,
            pending: true,
            error: null,
            active: false,
        }
    },
    components: {
        Artwork,
    },
    computed: {
        ...mapState({
            echoesContributions: state => state.echoesContributions,
        }),
        query() {
            return this.$route.query.id
        },
        artworks() {
            if (!this.data) {
                return []
            }
            const result = [...this.data]
            for (const item of this.echoesContributions) {
                if (item.acf.artists && item.acf.artists.find(a => a.ID === this.item.ID)) {
                    result.push(item)
                }
            }
            return result
        }
    },
    mounted() {
        this.load();
        let self = this;
        setTimeout(function() {
            if (self.query && self.query != "" && self.query == self.item.ID) {
                self.open();
            }
        }, 1500)
    },
    methods: {
        async open() {
            if (!this.data) {
                this.requestData();
            }
            this.active = !this.active;
        },
        load() {
            this.status = true;
        },
        async requestData() {
            this.pending = true
            try {
                const { data } = await axios.get(`${this.$store.state.api}/get_artworks_by_artist`, {
                    params: { id: this.item.ID },
                })
                this.data = data ? data : [];
                this.error = false;
            } catch (e) {
                this.data = null;
                this.error = e;
            }
            this.pending = false;
        }
    },
    watch: {
        active(n, o) {
            this.$nextTick(() => {
                
                let self = this;
                let t = document.getElementById(this.item.post_name);
                let accordions = document.querySelectorAll('.artist-accordion');
                //chiudiamo tutto
                //dobbiamo fare qualche calcolo in piu perchè l'accordion non riesce a tenere di defaulr
                //l'altezza dei vari accordion interni
                //dunque dobbiamo continuare a cacolare l'altezza
                accordions.forEach(function(t) {
                    setTimeout(function() {
                        t.style.height = t.scrollHeight + "px";
                    }, 0)

                })

                accordions.forEach(function(t) {
                    setTimeout(function() {
                        t.style.height = 0;
                    }, 5)
                    //self.active = false;
                })

                if (n) {
                    if (t.offsetHeight == 0) {
                        setTimeout(function() {
                            t.style.height = t.scrollHeight + "px";
                        }, 50)

                        //Se non mettiamo questo auto non funziona l'altezza se apriamo gli accordion interni
                        setTimeout(function() {
                            t.style.height = "auto";
                        }, 1000)
                    }
                }

            })
        },
        query(n, o) {
            let self = this;
            if (n && n != o) {
                if (n.toString() == this.item.ID.toString()) {
                    console.log("dovresti aprire " + this.item.ID + " con il nome " + this.item.post_name)
                    setTimeout(function() {
                        self.open();
                    }, 1500)
                }
            }
        }
    }
}
</script>